import * as React from 'react';
import { DATA_TEST_ID } from '../data-test-id';
import HeaderLogo from '../../../static/assets/LogicManagerLogoWhite.png';
import SmallHeaderLogo from '../../../static/assets/LogicManagerLogoTriangleWhite.png';

export const Header: React.FunctionComponent<IHeaderProps> =
  React.memo((props: IHeaderProps) => {
    if (props.logoUrl === null) {
      return (
        <div className="header-bar" data-test-id={DATA_TEST_ID.HEADER_BAR} />
      );
    }
    if (props.logoUrl !== '') {
      return (
        <div className="header-bar" data-test-id={DATA_TEST_ID.HEADER_BAR}>
          <div className="custom-logo">
            <img src={SmallHeaderLogo} />
            <div className="vertical-line" />
            <img src={props.logoUrl} />
          </div>
        </div>
      );
    }
    return (
      <div className="header-bar" data-test-id={DATA_TEST_ID.HEADER_BAR}>
        <img className="header-logo" src={HeaderLogo}/>
      </div>
    );
  }
);

interface IHeaderProps {
  readonly logoUrl?: string;
}
